/**
 * Z4-Lib RUM instance holder. The instance is set from the app entry point
 * (initZ4Rum) so CloudWatch RUM receives sanitized page IDs (e.g. /reviews/:id).
 */

let rumInstance: { dispatch?: () => void } | null = null;

export function setZ4RumInstance(rum: { dispatch?: () => void } | null): void {
  rumInstance = rum;
}

export function flushZ4Rum(): void {
  rumInstance?.dispatch?.();
}
